export const EAQ_PRODUCT_TYPES = ['sherpath_component_nss', 'eaqng_ia'];
